import React from 'react';
import 'AppSrc/core/style/components/form/field-warning-error.css';
import { WarningTriangleFilled } from 'AppSrc/core/components/common/svg-icons';

const FieldWarningError = React.memo(({ className }) => (
  <span className={className ? `${className} field-warning-error-wrap` : 'field-warning-error field-warning-error-wrap'}>
    <span className="warning-svg-wrapper">
      <span className="warning-svg">
        <WarningTriangleFilled />
      </span>
    </span>
  </span>
));

export { FieldWarningError };
